<canvas id="idCanvasPaq_{{this.indexI}}" width="215" height="215">su navegador no soporta canvas</canvas>   